import { string } from 'yup'

export const passwordErrorMap = [
  {
    label: 'min',
    message: 'Minimum 8 characters',
  },
  {
    label: 'one_special_char',
    message: 'One special character',
  },
  {
    label: 'one_uppercase_and_lowercase_char',
    message: 'One uppercase and lowercase character',
  },
  {
    label: 'one_number',
    message: 'One number',
  },
]

export const requiredString = () => string().required('This field is required')

export const passwordValidationString = () => {
  return requiredString()
    .min(8, 'min')
    .max(32, 'max')
    .matches(/[$*@!#%&()^~{}-]+/, 'one_special_char')
    .matches(/[A-Z]+/, 'one_uppercase_and_lowercase_char')
    .matches(/[a-z]+/, 'one_uppercase_and_lowercase_char')
    .matches(/\d/, 'one_number')
}
